import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './en/translation.json';
import hw from './hw/translation.json';
import { ConvertedToObjectType } from './types';

const DEFAULT_LANGUAGE = 'hw';

const translationsJson = {
  en: {
    translation: en,
  },
  hw: {
    translation: hw,
  },
};

export type TranslationResource = typeof en;
export type LanguageKey = keyof TranslationResource;

export const translations: ConvertedToObjectType<TranslationResource> = {} as any;

const convertLanguageJsonToObject = (obj: any, dict: any, current?: string) => {
  Object.keys(obj).forEach(key => {
    const currentLookupKey = current ? `${current}.${key}` : key;
    if (typeof obj[key] === 'object') {
      dict[key] = {};
      convertLanguageJsonToObject(obj[key], dict[key], currentLookupKey);
    } else {
      dict[key] = currentLookupKey;
    }
  });
};

const setDocumentDirection = (language: string) => {
  const direction = language === DEFAULT_LANGUAGE ? 'rtl' : 'ltr';

  document.documentElement.lang = language;
  document.documentElement.dir = direction;
  document.body.dir = direction;
};

const savedLanguage = localStorage.getItem('i18nextLng') || DEFAULT_LANGUAGE;

setDocumentDirection(savedLanguage);

export const i18n = i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init(
    {
      resources: translationsJson,
      fallbackLng: DEFAULT_LANGUAGE,
      lng: savedLanguage,
      debug: false,
      interpolation: {
        escapeValue: false,
      },
      detection: {
        order: ['localStorage', 'navigator'],
        caches: ['localStorage'],
        lookupLocalStorage: 'i18nextLng',
      },
    },
    () => {
      convertLanguageJsonToObject(en, translations);
      setDocumentDirection(i18next.language || DEFAULT_LANGUAGE);
    },
  );

i18next.on('languageChanged', language => {
  setDocumentDirection(language);
});